function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17 .5c6.396 0 10.594.788 13.153 3.347C32.713 6.406 33.5 10.604 33.5 17c0 6.396-.788 10.594-3.347 13.153C27.594 32.713 23.396 33.5 17 33.5c-6.396 0-10.594-.788-13.153-3.347C1.287 27.594.5 23.396.5 17c0-6.396.788-10.594 3.347-13.153C6.406 1.287 10.604.5 17 .5z",
  stroke: "url(#curvature_svg__paint0_linear_6330_1722)"
});

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "curvature_svg__paint0_linear_6330_1722",
  x1: 0,
  y1: -9,
  x2: 31,
  y2: 36,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7DB5FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.58,
  stopColor: "#348FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0073FF"
})));

var SvgCurvature = function SvgCurvature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgCurvature;